import {
  REQUEST_GET_LIST_RESTAURANT,
  REQUEST_GET_LIST_RESTAURANT_SUCCESS,
  REQUEST_GET_LIST_RESTAURANT_ERROR,
  REQUEST_GET_SEATS_AND_SLOTS,
  REQUEST_GET_SEATS_AND_SLOTS_SUCCESS,
  REQUEST_GET_SEATS_AND_SLOTS_ERROR,
  REQUEST_GET_RESERVATIONS,
  REQUEST_GET_RESERVATIONS_SUCCESS,
  REQUEST_GET_RESERVATIONS_ERROR,
  REQUEST_CREATE_RESTAURANT_CONFIG,
  REQUEST_CREATE_RESTAURANT_CONFIG_SUCCESS,
  REQUEST_CREATE_RESTAURANT_CONFIG_ERROR,
  REQUEST_UPDATE_RESTAURANT_CONFIG,
  REQUEST_UPDATE_RESTAURANT_CONFIG_SUCCESS,
  REQUEST_UPDATE_RESTAURANT_CONFIG_ERROR,
  REQUEST_CREATE_ALACARTE,
  REQUEST_CREATE_ALACARTE_SUCCESS,
  REQUEST_CREATE_ALACARTE_ERROR
} from "../actions";

// import { arrayToObject } from '../../helpers/Utils';

// import { addSoftFields } from './saga';

const INIT_STATE = {
  getRestaurants: [],
  getRestaurantLoading: true,
  getRestaurantError: "",
  updateRestaurantLoading: false,
  createRestaurantLoading: false,
  createRestaurantConfig: [],
  createRestaurantError: "",
  updateRestaurantError: "",
  getSeatsAndSlots: {},
  getSeatsAndSlotsLoading: false,
  getSeatsAndSlotsError: "",
  getReservations: [],
  getReservationsLoading: false,
  getReservationsError: "",
  getReservationOptions: [],
  // mainCoursesAlacarte: {},
  createAlacarteRequestLoading: false,
  createAlacarteRequest: [],
  createAlacarteRequestError: ""
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_GET_LIST_RESTAURANT:
      return { ...state, getRestaurantLoading: true };
    case REQUEST_GET_LIST_RESTAURANT_SUCCESS: {
      if (action.payload.length > 0) {
        const { payload } = action;
        // let restaurantMenu = payload.map((res, index) => {
        //   return {
        //     [res.id]: {
        //       menu: [
        //         ...Object.values(
        //           res.menu
        //             .filter(res => res.title == ('MAIN COURSES' || 'ANA YEMEK'))
        //             .map(res => ({
        //               ...res.items.map(res => {
        //                 return {
        //                   [res.id]: {
        //                     title: res.title
        //                   }
        //                 };
        //               })
        //             }))[0]
        //         )
        //       ]
        //     }
        //   };
        // });

        const optionsForAlacarteReservations = payload.map((res, index) => {
          return {
            label: res.name,
            value: res.id,
            isLeaf: false
          };
        });

        return {
          ...state,
          getRestaurantLoading: false,
          getRestaurants: action.payload,
          getReservationOptions: optionsForAlacarteReservations,
          // mainCoursesAlacarte: { ...restaurantMenu },
          getRestaurantError: ""
        };
      }
      return {
        ...state,
        getRestaurantLoading: false
      };
    }
    case REQUEST_GET_LIST_RESTAURANT_ERROR:
      // console.error('get hotel restaurant action error:', action);
      return { ...state, getRestaurantLoading: false, getRestaurantError: action.payload };

    case REQUEST_GET_SEATS_AND_SLOTS:
      return { ...state, getSeatsAndSlotsLoading: true };
    case REQUEST_GET_SEATS_AND_SLOTS_SUCCESS: {
      const allSeatsAndSlotsItems = { ...state.getSeatsAndSlots, [action.payload.id]: action.payload };
      return {
        ...state,
        getSeatsAndSlotsLoading: false,
        getSeatsAndSlots: { ...allSeatsAndSlotsItems },
        getSeatsAndSlotsError: ""
      };
    }
    case REQUEST_GET_SEATS_AND_SLOTS_ERROR:
      // console.error('get seats and slots action error:', action);
      return { ...state, getSeatsAndSlotsLoading: false, getSeatsAndSlotsError: action.payload };

    case REQUEST_GET_RESERVATIONS:
      return { ...state, getReservationsLoading: true };
    case REQUEST_GET_RESERVATIONS_SUCCESS: {
      return {
        ...state,
        getReservationsLoading: false,
        getReservations: action.payload,
        getReservationsError: ""
      };
    }
    case REQUEST_GET_RESERVATIONS_ERROR:
      // console.error('get reservations action error:', action);
      return { ...state, getReservationsLoading: false, getReservationsError: action.payload };

    case REQUEST_CREATE_RESTAURANT_CONFIG:
      return { ...state, createRestaurantLoading: true };
    case REQUEST_CREATE_RESTAURANT_CONFIG_SUCCESS: {
      return {
        ...state,
        createRestaurantLoading: false,
        createRestaurantConfig: action.payload,
        createRestaurantError: ""
      };
    }
    case REQUEST_CREATE_RESTAURANT_CONFIG_ERROR:
      // console.error('create restaurant config action error:', action);
      return { ...state, createRestaurantLoading: false, createRestaurantError: action.payload };

    case REQUEST_CREATE_ALACARTE:
      return { ...state, createAlacarteRequestLoading: true };
    case REQUEST_CREATE_ALACARTE_SUCCESS: {
      return {
        ...state,
        createAlacarteRequestLoading: false,
        createAlacarteRequest: action.payload,
        createAlacarteRequestError: ""
      };
    }
    case REQUEST_CREATE_ALACARTE_ERROR:
      // console.error('create request alacarte action error:', action);
      return { ...state, createAlacarteRequestLoading: false, createAlacarteRequestError: action.payload };

    case REQUEST_UPDATE_RESTAURANT_CONFIG:
      return { ...state, updateRestaurantLoading: true };
    case REQUEST_UPDATE_RESTAURANT_CONFIG_SUCCESS: {
      // const items = { ...state.getRestaurants, [action.payload]: action.payload };
      // const itemsUpdate = Object.values(items);
      return {
        ...state,
        updateRestaurantLoading: false,
        getRestaurants: [...state.getRestaurants],
        updateRestaurantError: ""

        // ...state,
        // // loading: true,
        // addBookingLoading: false,
        // allBookingItems: { ...allBookingItemsObj },
        // bookingItems: [...Object.values(allBookingItemsObj)]
      };
    }
    case REQUEST_UPDATE_RESTAURANT_CONFIG_ERROR:
      // console.error('update restaurant config action error:', action);
      return { ...state, updateRestaurantLoading: false, updateRestaurantError: action.payload };

    default:
      return state;
  }
};
